import * as types from '../mutation-types';
import api from '@/store/utils/api';

const state = {
    currentLead: {},
};

const getters = {
    currentLead: state => state.currentLead,
};

const actions = {
    getLead({ commit, rootGetters }, payload) {
        return api.get(`/creditapp/pin/${payload.clientId}/${payload.leadId}/${payload.pin}/`).then(res => {
            commit(types.UPDATE_CURRENT_LEAD, res);
            return res;
        });
    },
    clearLead({ commit }) {
        const promise = Promise.resolve({});
        promise.then((res) => {
            commit(types.UPDATE_CURRENT_LEAD, res);
            return res;
        });
    },
    patchLead({ commit }, payload) {
        const apiUrl = `/leads/${payload.id}/`;

        return api
            .patch(apiUrl, payload)
            .then(res => commit(types.UPDATE_CURRENT_LEAD, res));
    },
};

const mutations = {
    [types.UPDATE_CURRENT_LEAD](state, payload) {
        state.currentLead = payload;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
